import { sharedNeutrals } from "@themes/tokens/shared";
// This factory is called from dozens of plain data/column-builder modules
// (many are .ts, not .tsx components) to produce a tooltipText value ahead of
// render — there's no component instance here to call useTheme() from, and no
// theme is threaded through any of those call sites. Kept as raw literals
// matching theme.typography.fontWeightMedium (500) / fontWeightRegular (400).
export const createTooltipWithTitle = (title: string, content: string) => {
  return (
    <div>
      <div style={{ color: sharedNeutrals.white, fontWeight: 500 }}>
        <strong>{title}</strong>
      </div>
      <p style={{ fontWeight: 400, margin: 0 }}>{content}</p>
    </div>
  );
};
